import AxiosClient from "../../../services/axios.services";

class CriticidadServices {
  getCriticidad = (params) =>
    AxiosClient.get("/api/app/carrera_sucesion_criticidad/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveCriticidad = (data) =>
    AxiosClient.post("/api/app/carrera_sucesion_criticidad/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCriticidad = (id, data) =>
    AxiosClient.put(`/api/app/carrera_sucesion_criticidad/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCriticidad = (id) =>
    AxiosClient.delete(`/api/app/carrera_sucesion_criticidad/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CriticidadServices();
